export class Constants {
  userDataName = 'wtm-u';
  cookieDataName = 'wtm-ck';
  cookieRolesName = 'wtm-r';
}
